import { z } from 'zod'

// TODO: replace 'VY' with 'IB & 'vueling' with 'iberia'
export const IataSchema = z.enum(['EI', 'BA', 'VY'])

export type Iata = z.infer<typeof IataSchema>

// TODO: add 'IBP' to programme list
export const ProgramIdentifierSchema = z.enum(['BAEC', 'AERC', 'ATRP'])

export type ProgramIdentifier = z.infer<typeof ProgramIdentifierSchema>

export const OpCoClassNameSchema = z.enum(['aer_lingus', 'british_airways', 'vueling'])

export type OpCoClassName = z.infer<typeof OpCoClassNameSchema>

export const OpCoConfigSchema = z.object({
  iataCode: IataSchema,
  key: OpCoClassNameSchema,
  name: z.string(),
})

export type OpCoConfig = z.infer<typeof OpCoConfigSchema>
